import { Icon, Loading, TIconName } from 'components';
import React, { ComponentProps, memo, MouseEventHandler, useCallback } from 'react';
import { useHistory } from 'react-router';

import { StyledButton, IStyledButton, LeftIconContainer, RightIconContainer } from './styles';

type TIconProp = ComponentProps<typeof Icon> | TIconName;
export interface IButtonProps extends IStyledButton {
  leftIcon?: TIconProp;
  rightIcon?: TIconProp;
  isLoading?: boolean;
  href?: string;
  variant?: 'primary' | 'cancel' | 'danger' | 'secondary' | 'gray' | 'accept';
}

const ButtonComponent: React.FC<IButtonProps> = ({
  leftIcon,
  rightIcon,
  isLoading,
  href,
  onClick,
  ...props
}) => {
  const history = useHistory();

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    e => {
      onClick?.(e);

      if (href) history.push(href);
    },
    [onClick, href],
  );

  return (
    <StyledButton onClick={handleClick} {...props}>
      {leftIcon && (
        <LeftIconContainer>
          <Icon {...(typeof leftIcon === 'string' ? { name: leftIcon } : leftIcon)} />
        </LeftIconContainer>
      )}

      {isLoading ? <Loading size={1.3} /> : props.children}

      {rightIcon && (
        <RightIconContainer>
          <Icon {...(typeof rightIcon === 'string' ? { name: rightIcon } : rightIcon)} />
        </RightIconContainer>
      )}
    </StyledButton>
  );
};

export const Button = memo(ButtonComponent);
